import o from"./_baseGetTag.js";import t from"./isObjectLike.js";var e=o,r=t;var a=function(o){return"symbol"==typeof o||r(o)&&"[object Symbol]"==e(o)};export{a as default};
//# sourceMappingURL=isSymbol.js.map
